export enum Role {
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  TECHNICIAN = 'TECHNICIAN',
  USER = 'USER',
  ADMIN_READ_ONLY = 'ADMIN_READ_ONLY',
  MANAGER_READ_ONLY = 'MANAGER_READ_ONLY',
  ENGINEER = 'ENGINEER'

}
